import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import { View, YStack, Button, Text } from "tamagui";
import { containerStyle } from "@styles/index";
import RadiusContentWrapper from "@components/layout/RadiusContentWrapper";
import Header from "@components/layout/Header";
import { colors } from "@styles/colors";
import Steper from "./components/Steper";
import { RiArrowLeftSLine } from "react-icons/ri";
import { isPracticeMode } from "@utils/practice/practiceMode";

const stepInfoData = {
  inviteCode: { step: "2", headerTitle: "輸入客戶序號", decs: "由您的瓦斯行提供,可自動帶入帳號資料" },
};

const getTargetStepInfoData = (pathname: string) => {
  type StepKey = keyof typeof stepInfoData;
  const targetKey = Object.keys(stepInfoData).find((key) => pathname.includes(key)) as StepKey | undefined;
  const targetData = targetKey ? stepInfoData[targetKey] : null;
  //-- 判斷是否為第一步驟
  const minStep = Math.min(...Object.values(stepInfoData).map((v) => Number(v.step)));
  const isFirstStep = targetData ? Number(targetData.step) === minStep : false;
  //-- 返回路徑
  const sortedEntries = Object.entries(stepInfoData).sort((a, b) => Number(a[1].step) - Number(b[1].step));
  const currentIndex = sortedEntries.findIndex(([key]) => key === targetKey);
  const prevKey = (currentIndex > 0 ? sortedEntries[currentIndex - 1][0] : null) as StepKey | undefined;
  const prevData = prevKey ? stepInfoData[prevKey] : null;

  let prevPathname = "";
  if (!isFirstStep) {
    prevPathname = `/register/${prevKey}`;
    if (prevData?.step === "2") {
      prevPathname = `/register/step${prevData?.step}/${prevKey}`;
    }
  }

  return { targetData, isFirstStep, prevPathname };
};

const RegisterPageRoutes = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const { targetData, isFirstStep, prevPathname } = getTargetStepInfoData(location?.pathname);

  return (
    <View {...containerStyle} height="100dvh" width="100vw" background={colors.bg}>
      <View flex={1} w={"100%"}>
        <Header>
          <YStack>
            {/* 第一步（客戶序號）返回既有客戶入口；其餘步驟返回上一步。樣式對齊其他頁。
                練習模式的第一步＝情境入口，不顯示返回鍵（避免退出情境到既有客戶入口）；深層步驟照常可返回。 */}
            {!(isFirstStep && isPracticeMode()) && (
              <Link to={isFirstStep ? "/register/existing" : prevPathname} style={{ marginBottom: 8 }}>
                <Text fontSize={13} color="rgba(255, 255, 255, 0.75)" style={{ display: "flex", alignItems: "center" }}>
                  <RiArrowLeftSLine size={20} color={colors.light} style={{ marginRight: 4 }} />
                  返回
                </Text>
              </Link>
            )}
            <Text fontSize={20} fontWeight="700" color="#FFF">
              {targetData?.headerTitle}
            </Text>
            <Text fontSize={14} color="rgba(255, 255, 255, 0.65)">
              {targetData?.decs}
            </Text>
            {Object.keys(stepInfoData).length > 1 && (
              <div className="mt-2">
                <Steper total={Object.keys(stepInfoData)?.length} current={Number(targetData?.step) - 1} />
              </div>
            )}
          </YStack>
        </Header>
        <RadiusContentWrapper>
          <Outlet />
        </RadiusContentWrapper>
      </View>
    </View>
  );
};

export default RegisterPageRoutes;
